// // Overlay button on Home page

// // Floating btn
document.addEventListener('DOMContentLoaded', function () {
  var btn;
  var closeBtn
  var windowHeight = window.innerHeight;


  // ウィンドウ幅が758px以上の場合
  if (window.innerWidth >= 758) {
    btn = document.querySelector('.floating-btn-desktop');
    closeBtn = document.getElementById('closeBtn-desktop');
  } else {
    btn = document.querySelector('.floating-btn-mobile');
    closeBtn = document.getElementById('closeBtn-mobile');
  }

  window.addEventListener('scroll', function () {
    var scrollPosition = window.scrollY || document.documentElement.scrollTop;

    if (scrollPosition > 500 && (scrollPosition + windowHeight < document.body.clientHeight)) {
      btn.classList.add('active');
      closeBtn.classList.add('active'); // スクロール位置が条件を満たすときにcloseBtnを表示
    } else {
      btn.classList.remove('active');
      closeBtn.classList.remove('active'); // スクロール位置が条件を満たさないときにcloseBtnを非表示
    }
  });

  // // ウィンドウのリサイズイベントリスナー
  window.addEventListener('resize', function () {
    // ウィンドウ幅が758px以上の場合は.desktop、それ以外の場合は.mobileボタンを選択
    if (window.innerWidth >= 758) {
      btn = document.querySelector('.floating-btn-desktop');
      closeBtn = document.getElementById('closeBtn-desktop');
    } else {
      btn = document.querySelector('.floating-btn-mobile');
      closeBtn = document.getElementById('closeBtn-mobile');
    }
  });


});



// Close btn

document.addEventListener('DOMContentLoaded', function () {
  var closeBtnDesktop = document.getElementById('closeBtn-desktop');
  var closeBtnMobile = document.getElementById('closeBtn-mobile');


  closeBtnDesktop.addEventListener('click', function (event) {
    event.preventDefault(); // デフォルトのイベントを停止

    var floatingBtnDesktop = document.querySelector('.floating-btn-desktop');
    var floatingBtnMobile = document.querySelector('.floating-btn-mobile');

    floatingBtnDesktop.style.display = 'none';
    floatingBtnMobile.style.display = 'none';
    closeBtnDesktop.style.display = 'none' // closeBtn-desktopも非表示にする
    closeBtnMobile.style.display = 'none' // closeBtn-desktopも非表示にする
  });

  closeBtnMobile.addEventListener('click', function (event) {
    event.preventDefault(); // デフォルトのイベントを停止

    var floatingBtnDesktop = document.querySelector('.floating-btn-desktop');
    var floatingBtnMobile = document.querySelector('.floating-btn-mobile');

    floatingBtnDesktop.style.display = 'none';
    floatingBtnMobile.style.display = 'none';
    closeBtnMobile.style.display = 'none' // closeBtn-desktopも非表示にする
    closeBtnDesktop.style.display = 'none' // closeBtn-desktopも非表示にする
  });
});
